

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class BusinessArea_ManagedObject

class BusinessArea_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Relationship: emailTemplates
    protected _emailTemplates:MIOManagedObjectSet = null;
    get emailTemplates():MIOManagedObjectSet {
        return this.valueForKey('emailTemplates');
    }
    addEmailTemplatesObject(value:EmailTemplate) {
        this._addObjectForKey(value, 'emailTemplates');
    }
    removeEmailTemplatesObject(value:EmailTemplate) {
        this._removeObjectForKey(value, 'emailTemplates');
    }

    // Relationship: locationCategories
    protected _locationCategories:MIOManagedObjectSet = null;
    get locationCategories():MIOManagedObjectSet {
        return this.valueForKey('locationCategories');
    }
    addLocationCategoriesObject(value:LocationCategory) {
        this._addObjectForKey(value, 'locationCategories');
    }
    removeLocationCategoriesObject(value:LocationCategory) {
        this._removeObjectForKey(value, 'locationCategories');
    }

    // Relationship: timeRangePresetConfigurations
    protected _timeRangePresetConfigurations:MIOManagedObjectSet = null;
    get timeRangePresetConfigurations():MIOManagedObjectSet {
        return this.valueForKey('timeRangePresetConfigurations');
    }
    addTimeRangePresetConfigurationsObject(value:TimeRangePresetConfiguration) {
        this._addObjectForKey(value, 'timeRangePresetConfigurations');
    }
    removeTimeRangePresetConfigurationsObject(value:TimeRangePresetConfiguration) {
        this._removeObjectForKey(value, 'timeRangePresetConfigurations');
    }
}
